import { LessonId } from 'types';

export const LESSONS = '/api/v1/lessons';
export const LESSONS_WITHOUT_TOPIC = '/api/v1/lessons/without-topic';
export const LESSONS_EMPLOYEES = '/api/v1/lessons/employees';
export const LESSONS_JOURNALS = '/api/v1/lessons/journals';
export const COMMON_JOURNALS = '/api/v1/lessons/common-journals';
export const LESSON = (lessonId: LessonId) => `/api/v1/lessons/${lessonId}`;
export const UNASSIGNED_CHILDREN = (lessonId: LessonId) =>
    `/api/v1/lessons/${lessonId}/unassigned-children`;
